import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { useAuth } from '../../context/AuthContext';
import Spinner from '../common/Spinner';
import './PendingDeletion.scss';

const PendingDeletion: React.FC = () => {
  const { formatMessage: t, formatDate } = useIntl();
  const { deletionDueAt, restoreAccount, signOut } = useAuth();
  const [restoring, setRestoring] = useState(false);
  const [error, setError] = useState(false);

  const handleRestore = async () => {
    setRestoring(true);
    setError(false);
    try {
      await restoreAccount();
    } catch {
      setError(true);
      setRestoring(false);
    }
  };

  const date = deletionDueAt
    ? formatDate(deletionDueAt, { day: 'numeric', month: 'long', year: 'numeric' })
    : '';

  return (
    <div className="pending-deletion">
      <div className="pending-deletion__card" role="alert">
        <h1 className="pending-deletion__title">{t({ id: 'account.pending.title' })}</h1>
        <p className="pending-deletion__body">{t({ id: 'account.pending.body' }, { date })}</p>
        {error && <p className="pending-deletion__error">{t({ id: 'account.pending.error' })}</p>}
        <div className="pending-deletion__actions">
          <button
            type="button"
            className="pending-deletion__secondary"
            disabled={restoring}
            onClick={() => void signOut()}
          >
            {t({ id: 'auth.signOut' })}
          </button>
          <button
            type="button"
            className="pending-deletion__primary"
            disabled={restoring}
            onClick={() => void handleRestore()}
          >
            {restoring ? <Spinner size="sm" /> : t({ id: 'account.pending.restore' })}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PendingDeletion;
